'use client';

import { useTranslations } from 'next-intl';
import { FeatureDetailContent } from './FeatureDetailContent';
import {
    Bitcoin,
    Shield,
    Zap,
    DollarSign,
    Lock,
    Globe
} from 'lucide-react';

export function CryptoCurrencyMLMSoftwareContent() {
    const t = useTranslations('cryptoCurrencyMLMSoftware');

    const features = [
        {
            icon: Bitcoin,
            title: t('features.step1.title'),
            description: t('features.step1.description'),
        },
        {
            icon: Shield,
            title: t('features.step2.title'),
            description: t('features.step2.description'),
        },
        {
            icon: Zap,
            title: t('features.step3.title'),
            description: t('features.step3.description'),
        },
        {
            icon: DollarSign,
            title: t('features.step4.title'),
            description: t('features.step4.description'),
        },
        {
            icon: Lock,
            title: t('features.step5.title'),
            description: t('features.step5.description'),
        },
        {
            icon: Globe,
            title: t('features.step6.title'),
            description: t('features.step6.description'),
        },
    ];

    // Get benefits list from translations, ensuring it's always an array
    const benefitsRaw = t.raw('benefits.list');
    const benefits = Array.isArray(benefitsRaw) ? benefitsRaw : (benefitsRaw ? [benefitsRaw] : []);

    return (
        <FeatureDetailContent
            pageKey="crypto-currency-mlm-software"
            translationNamespace="cryptoCurrencyMLMSoftware"
            features={features}
            benefits={benefits}
            ctaIcon={Bitcoin}
            showWhatIsBitcoin={false}
            introImageSrc="/images/features/Crypto-currency.webp"
            introImageAlt={t('intro.imageAlt') || 'Crypto Currency MLM Software'}
            introParagraphKeys={['paragraph2', 'paragraph3']}
            introSectionHeadingPage="crypto-currency-mlm-software"
            introSectionHeadingTitle={t('intro.sectionHeadingTitle') || 'About Crypto Currency MLM Software'}
            introSectionHeadingPill={t('intro.sectionHeadingPill') || 'Crypto Currency'}
            useLocaleContent={true}
        />
    );
}

